import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Chip,
  InputAdornment,
  Divider,
  Typography,
} from "@mui/material";
import { NumericFormatCurrency, NumericFormatUnit } from "../utils/formatters";
import { useTranslation } from "react-i18next";

export default function PriceStockSection({
  formData,
  handleText,
  precoBase,
  precoFinal,
  economia,
  economiaPct,
  descontoValido,
}) {
  const { t } = useTranslation("products");
  const chipLabel =
    precoBase > 0
      ? economia > 0
        ? t("form.finalPriceWithSavings", {
            price: precoFinal.toFixed(2),
            savings: economia.toFixed(2),
            pct: economiaPct.toFixed(1),
          })
        : t("form.finalPriceLabel", { price: precoFinal.toFixed(2) })
      : t("form.finalPriceEmpty");
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.priceStockTitle")}
        action={
          <Chip
            label={chipLabel}
            color="primary"
            variant="outlined"
            size="small"
          />
        }
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.suggestedPriceRequired")}
              name="preco"
              value={formData.preco}
              onChange={handleText}
              required
              fullWidth
              InputProps={{ inputComponent: NumericFormatCurrency }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.dealerPrice")}
              name="preco_comdesconto"
              value={formData.preco_comdesconto}
              onChange={handleText}
              fullWidth
              InputProps={{ inputComponent: NumericFormatCurrency }}
              error={!descontoValido}
              helperText={
                !descontoValido
                  ? t("form.dealerPriceError")
                  : t("form.dealerPriceHelper")
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("form.stockRequired")}
              name="estoque"
              value={formData.estoque}
              onChange={handleText}
              required
              fullWidth
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: (
                  <InputAdornment position="end">{t("form.stockUnits")}</InputAdornment>
                ),
              }}
              inputProps={{ decimalScale: 0 }}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 0.5 }}>
              {t("form.shippingForFreightTitle")}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
              {t("form.shippingForFreightIntro")}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.weightKgLabel")}
              name="peso"
              value={formData.peso}
              onChange={handleText}
              fullWidth
              helperText={t("form.weightKgHelper")}
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: (
                  <InputAdornment position="end">{t("form.weightKgUnit")}</InputAdornment>
                ),
              }}
              inputProps={{ decimalScale: 3 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label={t("table.colLargura")}
              name="largura"
              value={formData.largura}
              onChange={handleText}
              fullWidth
              helperText={t("form.packageDimensionsHelper")}
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: (
                  <InputAdornment position="end">{t("form.dimensionCmUnit")}</InputAdornment>
                ),
              }}
              inputProps={{ decimalScale: 2 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("table.colAltura")}
              name="altura"
              value={formData.altura}
              onChange={handleText}
              fullWidth
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: (
                  <InputAdornment position="end">{t("form.dimensionCmUnit")}</InputAdornment>
                ),
              }}
              inputProps={{ decimalScale: 2 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={t("table.colComprimento")}
              name="comprimento"
              value={formData.comprimento}
              onChange={handleText}
              fullWidth
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: (
                  <InputAdornment position="end">{t("form.dimensionCmUnit")}</InputAdornment>
                ),
              }}
              inputProps={{ decimalScale: 2 }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
